<template>
  <main-content-layout :title="$gettext('BILLINGS')">
    <div id="header" class="tw-text-gray-700 tw-fixed tw-shadow-lg">
      <div class="tw-bg-warmGray-100 top-area">
        <block-header
          v-for="(item, index) in headerItems"
          :key="index"
          :title="item.title"
          :content="item.content"
          :disable="item.disable"
        />
      </div>
      <div class="buttons-area">
        <div class="index-table tw-flex tw-items-center tw-gap-2">
          <invoice-situation
            v-for="situationName in displayedSituations"
            :key="situationName"
            :text="situationMap[situationName].text"
            :color="situationMap[situationName].color"
            @clickAction="filterInvoice"
          />
        </div>
        <div class="rigth-buttons">
          <q-btn
            :disable="isDisableNegotiationBtn"
            class="sub-teble-btn"
            flat
            @click="
              (p) => {
                openNegotiationModal(p);
              }
            "
          >
            <div class="row items-center no-wrap">
              <div class="text-center">{{ $gettext("NEGOTIATION") }}</div>
            </div>
          </q-btn>
          <q-btn
            :disable="isDisableNegotiationBtn"
            class="sub-teble-btn"
            flat
            @click="openExtensionModal"
          >
            <div class="row items-center no-wrap">
              <div class="text-center">{{ $gettext("EXTEND") }}</div>
            </div>
          </q-btn>
          <q-btn-dropdown
            flat
            class="sub-teble-btn"
            :disable="isDisableOneTimePayment"
          >
            <template #label v-if="isDisableOneTimePayment">
              <q-tooltip>
                {{ $gettext("ONE_TIME_PAYMENT") }}
              </q-tooltip>
              <div class="row items-center no-wrap">
                <q-icon left name="mdi-file-document-outline" size="20px" />
                <div class="text-center"> {{ $gettext("ONE_TIME_PAYMENT") }}</div>
              </div>
            </template>
            <template #label v-else>
              <div class="row items-center no-wrap">
                <q-icon left name="mdi-file-document-outline" size="20px" />
                <div class="text-center">{{ $gettext("ONE_TIME_PAYMENT") }}</div>
              </div>
            </template>
            <q-list>
              <q-item clickable v-close-popup @click="openInvoiceManagerOneTimePayment()">
                <q-item-section>
                  <q-item-label class="tw-flex tw-gap-2">
                    <q-icon name="mdi-file-download-outline" size="18px" />
                    <div class="text-center">
                      {{ $gettext("SECOND_COPY") }}
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-item clickable v-close-popup @click="showSendEmailDialogOneTimePayment">
                <q-item-section>
                  <q-item-label class="tw-flex tw-gap-2">
                    <q-icon name="mdi-email-outline" size="18px" />
                    <div class="text-center">
                      {{ $gettext("SEND_INVOICE") }}
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <q-btn-dropdown
            flat
            class="sub-teble-btn"
            :disable="isDisableInvoiceButton"
          >
            <template #label v-if="isDisableInvoiceButton">
              <q-tooltip>
                {{ invoiceButtonTooltip }}
              </q-tooltip>
              <div class="row items-center no-wrap">
                <q-icon lefAbertot name="mdi-file-document-outline" size="20px" />
                <div class="text-center">Boletos</div>
              </div>
            </template>
            <template #label v-else>
              <div class="row items-center no-wrap">
                <q-icon left name="mdi-file-document-outline" size="20px" />
                <div class="text-center">Boletos</div>
              </div>
            </template>
            <q-list>
              <q-item clickable v-close-popup @click="openInvoiceManager()">
                <q-item-section>
                  <q-item-label class="tw-flex tw-gap-2">
                    <q-icon name="mdi-file-download-outline" size="18px" />
                    <div class="text-center">
                      {{ $gettext("SECOND_COPY") }}
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-item clickable v-close-popup @click="showSendEmailDialog">
                <q-item-section>
                  <q-item-label class="tw-flex tw-gap-2">
                    <q-icon name="mdi-email-outline" size="18px" />
                    <div class="text-center">
                      {{ $gettext("SEND_INVOICE") }}
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <q-btn class="sub-teble-btn" flat @click="openModalFilter">
            <div class="row items-center no-wrap">
              <q-icon name="filter_list" size="20px" />
              <div class="text-center">{{ $gettext("FILTER") }}</div>
            </div>
          </q-btn>
        </div>
      </div>
    </div>
    <div
      v-for="(invoices, index) in invoicesByOwner"
      :key="index"
      :class="{ table: index === 0 }"
    >
      <header-colapse-table
        :class="{ 'tw-mt-2': index != 0 }"
        :consumerUnit="consumerUnit"
        :protocol="protocol"
        :ownerName="invoices[0].ownerName"
        :ownerDocument="invoices[0].ownerDocument"
        :isSigre="invoices[0].isSigre"
        :isCurrentOwner="index === 0"
        :isColapseStartIcon="index === 0"
        @colapse="() => toggleTable(index)"
      />

      <jt-data-table
        ref="jtDataTable"
        v-if="isOpen[index]"
        :api-mode="false"
        :data="invoices"
        :fields="columns"
        :is-paginated="false"
        :title="titleTeble"
        row-buttons
        @action-button="actionButton"
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-td auto-width>
              <q-checkbox
                v-if="
                  invoices[0].representative === 'true' ||
                  isOwnerInServiceRequest(invoices[0].ownerDocument)
                "
                v-model="allSelected[index]"
                @input="alterSelected(invoices[0].owner, index)"
                color="primary"
              />
            </q-td>
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td auto-width>
              <q-checkbox
                v-if="props.row.representative === 'true' || isOwnerInServiceRequest(props.row.ownerDocument)"
                v-model="props.row['selected']"
                color="primary"
              />
            </q-td>
            <q-td
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              style="color: #333"
            >
              <div v-if="col.field == 'ref'">
                <strong style="font-size: 14px">
                  {{ getInvoiceMonthOrReference(props.row) }}
                </strong>
                <br />
                <span>
                  {{ props.row["ano"] }}
                </span>
              </div>
              <span
                v-else-if="
                  col.field == 'vencimentoAtual' || col.field == 'dtvencto'
                "
              >
              <span style="font-size: 14px" v-if="props.row.valor != '0,00'" ></span>
                {{ props.row["dtvencto"] }}
              </span>
              <span v-else-if="col.field == 'invoiceStatus'">
                <invoice-situation
                 v-if="props.row.valor === '0,00'"
                  @clickAction="filterInvoice"
                  :text="$gettext('CANCELLED')"
                  color="#FFFFE0"
                />
                <invoice-situation
                  v-else-if="
                    !props.row.newValue || props.row.invoiceStatus == invoiceStatus.NEGOTIATION.key
                  "
                  @clickAction="filterInvoice"
                  :text="
                    getSituatinByKey(
                      props.row.isSigre ? props.row.situacao : col.value
                    ).text
                  "
                  :color="
                    getSituatinByKey(
                      props.row.isSigre ? props.row.situacao : col.value
                    ).color
                  "
                />
                <invoice-situation
                  v-else
                  @clickAction="filterInvoice"
                  :text="getSituatinByKey('Vencida').text"
                  :color="getSituatinByKey('Vencida').color"
                />
              </span>
              <span v-else-if="col.field == 'valor'" class="cell-values">
                <span style="font-size: 14px">
                  {{ $toLocaleStringBr(col.value) }}
                </span>

                <span style="font-size: 14px" v-if="props.row.dueOriginal">
                  {{
                    moment(props.row.dueOriginal, "DD/MM/YYYY HH:mm:ss").format(
                      "DD/MM/YYYY"
                    )
                  }}
                </span>
              </span>
              <span v-else-if="col.field == 'newValue'">
                <span style="font-size: 14px" v-if="shouldShowNewValue(props.row, col)">
                  {{ $toLocaleStringBr(col.value || props.row["newValue"]) }}
                </span>
                <span style="font-size: 14px" v-else-if="shouldShowRemainingDebt(props.row)">
                  {{ $toLocaleStringBr(props.row["remainingDebtValue"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'tipocob'">
                <span
                  v-if="col.value == 8 || col.value == 'BOLETO'"
                  style="font-size: 14px"
                >
                  Boleto
                </span>
                <span v-else style="font-size: 14px"> Convênio Samae </span>
              </span>
              <span v-else-if="col.field == 'dtpagto'" class="cell-values">
                <span v-if="props.row['vlpag'] && props.row.invoiceStatus != invoiceStatus.EXEMPT.key" style="font-size: 14px">
                  {{ $toLocaleStringBr(props.row["vlpag"]) }}
                </span>
                <span v-if="props.row.invoiceStatus != invoiceStatus.EXEMPT.key" style="font-size: 14px">
                  {{
                    col.value &&
                    moment(
                      col.value,
                      props.row.isSigre ? "YYYY-MM-DD" : "DD/MM/YYYY HH:mm:ss"
                    ).format("DD/MM/YYYY")
                  }}
                </span>
              </span>
              <span v-else-if="col.field == 'status'">
                <div style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center;">
                  <template v-if="props.row.agreementInvoiceStatus">
                    <div
                      v-for="status in JSON.parse(
                        props.row.agreementInvoiceStatus
                      )"
                      :key="status"
                      style="margin-right: 4px"
                    >
                      <q-icon
                        :name="getStatusIcon(status).icon"
                        size="20px"
                        :style="{ color: getStatusIcon(status).color }"
                      >
                        <q-tooltip class="bg-indigo">
                          {{ getStatusIcon(status).tooltip }}
                        </q-tooltip>
                      </q-icon>
                    </div>
                  </template>
                  <q-icon
                    v-if="props.row.paymentValue"
                    name="mdi-square-inc-cash"
                    size="20px"
                    class="payment-value"
                  >
                    <q-tooltip class="bg-indigo">{{ $gettext("PAYMENT_VALUE") }} R$ {{props.row.paymentValue}} </q-tooltip>
                  </q-icon>
                  <q-icon
                      v-if="props.row.abatementValue"
                      name="mdi-arrow-down-bold-hexagon-outline"
                      size="20px"
                      class="abatement-value"
                    >
                      <q-tooltip class="bg-indigo">{{ $gettext("ABATEMENT_VALUE") }} R$ {{props.row.abatementValue}} </q-tooltip>
                  </q-icon>
                  <q-icon
                      v-if="props.row.restitutionValue"
                      name="mdi-cash-multiple"
                      size="20px"
                      class="restitution-value"
                    >
                      <q-tooltip class="bg-indigo">{{ $gettext("RESTITUTION_VALUE") }} R$ {{props.row.restitutionValue}} </q-tooltip>
                  </q-icon>
                  <q-icon
                    v-if="col.value == 'J'"
                    name="gavel"
                    size="20px"
                    style="color: #8fe7d4; margin-right: 4px"
                  >
                    <q-tooltip class="bg-indigo">Judicializado</q-tooltip>
                  </q-icon>
                  <q-icon
                    v-else-if="Number(col.value) > 0"
                    name="mdi-account-details"
                    size="20px"
                    style="color: #e87d7d; margin-right: 4px"
                  >
                    <q-tooltip class="bg-indigo">
                      {{ $gettext("EXTERNAL_CONSULTANCY") }}
                    </q-tooltip>
                  </q-icon>
                  <template v-else-if="props.row['invoiceDocumentStatusId']">
                    <q-icon
                      v-if="
                        props.row['invoiceDocumentType'] == 50260003 ||
                        props.row['invoiceDocumentType'] == 50260004
                      "
                      name="mdi-cash-usd"
                      size="20px"
                      class="tw-text-skyWaste"
                      style="margin-right: 4px"
                    >
                      <q-tooltip class="bg-indigo">
                        {{ $gettext("Boleto do Acordo") }}
                      </q-tooltip>
                    </q-icon>
                    <q-icon
                      v-else
                      name="mdi-cash-usd"
                      size="20px"
                      :class="
                        colorInvoiceDocumentIcon(
                          props.row['invoiceDocumentStatusId']
                        )
                      "
                      style="margin-right: 4px"
                    >
                      <q-tooltip class="bg-indigo">
                        {{ props.row["invoiceDocumentStatus"] }}
                      </q-tooltip>
                    </q-icon>
                  </template>
                  <q-icon
                    v-if="props.row['isSigre']"
                    name="mdi-polymer"
                    size="20px"
                    style="
                      color: #ecdb00;
                      transform: rotate(90deg);
                      margin-right: 4px;
                    "
                  >
                    <q-tooltip class="bg-indigo">
                      {{ $gettext("SIGRE") }}
                    </q-tooltip>
                  </q-icon>
                </div>
              </span>
              <span v-else>
                {{ col.value }}
              </span>
            </q-td>
          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <div class="row hidden-row" style="color: #333">
                <div
                  v-for="(col, index) in props.cols.filter((p) => p.expandProd)"
                  :key="index"
                  style="padding: 5px 8px"
                  :class="index % 2 != 0 ? 'col-4' : 'col-4 row-paint-colapse'"
                >
                  <strong
                    ><label>{{ col.label }}:</label></strong
                  >
                  {{
                    col.field == "valor" || col.field == "vlpag"
                      ? toLocaleStringBr(props.row[col.field])
                      : props.row[col.field]
                  }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
    <send-email-invoice-dialog
      ref="sendEmailModal"
      :email-service-request="emailServiceRequest()"
      @on-ok-click="
        (email) => {
          sendEmailInvoices(email);
        }
      "
    />
    <JtDocsViewer
      :src="fileSrc"
      :title="invoiceDocumentTitle"
      pdf
      ref="reportModal"
    />
    <modal
      ref="writeOffModal"
      v-if="writeOff.show"
      :show="writeOff.show"
      :forms="writeOff.forms"
      :label="this.$gettext('WRITE_OFF')"
      @input="
        function hideModal() {
          writeOff.show = false;
        }
      "
      @action-button="actionButtonWriteOff"
    />
    <modal
      v-if="modalFilter.show"
      ref="filterModal"
      :show="modalFilter.show"
      :forms="modalFilter.forms"
      :label="this.$gettext('FILTER')"
      @action-button="actionButtonFilter"
      @input="
        function hideModal() {
          modalFilter.show = false;
        }
      "
    />
    <extension-modal
      :show="modalExtension.show"
      :consumerUnit="consumerUnit"
      :protocol="protocol"
      @input="
        function hideModal() {
          modalExtension.show = false;
        }
      "
    />
    <negotiation-modal
      :show="modalNegotiation.show"
      :consumerUnit="consumerUnit"
      :protocol="protocol"
      @input="
        function hideModal() {
          modalNegotiation.show = false;
          negotiationController.clearModalData();
          updateTable();
        }
      "
    />
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../../../ServiceRequestController'
import ServiceRequestInvoiceController from './ServiceRequestInvoiceController'
import { QBtn } from 'quasar'
import { JtCrud, JtDataTable, JtDocs } from 'jtech-webcomps'
import InvoiceSituation from './component/InvoiceSituation.vue'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
import { situationMap } from './component/situation.config'
import moment from 'moment'
import { getInvoiceMonthOrReference } from 'src/shared/global/UtilInvoice'
import { messageBox, repository } from 'src/jtech'
import SendEmailInvoiceDialog from './component/SendEmailInvoiceDialog.vue'
import HeaderColapseTable from './component/serviceRequestInvoice/HeaderColapseTable.vue'
import BlockHeader from './component/serviceRequestInvoice/BlockHeader.vue'
import NegotiationController from './negotiation/NegotiationController'
import ExtensionController from './extension-invoice/ExtensionController'
import ExtensionModal from './extension-invoice/ExtensionModal.vue'
import NegotiationModal from './negotiation/NegotiationModal.vue'
import ConsentLetterModel from 'src/modules/consent-letter/consent-letter/ConsentLetterModel'
import { invoiceStatus } from 'src/shared/inf-tabela-descricao/InvoiceStatus.enum.js'

const { modal } = JtCrud

const { JtDocsViewer } = JtDocs

@Component({
  name: 'ServiceRequestInvoice',
  components: {
    QBtn,
    InvoiceSituation,
    JtDataTable,
    MainContentLayout,
    modal,
    JtDocsViewer,
    SendEmailInvoiceDialog,
    BlockHeader,
    HeaderColapseTable,
    ExtensionModal,
    NegotiationModal
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestInvoice extends Vue {
  controller = ServiceRequestController.getInstance();
  invoiceController = ServiceRequestInvoiceController.getInstance();
  negotiationController = NegotiationController.getInstance();
  extensionController = ExtensionController.getInstance();

  allSelected = [];
  data = [];
  dataAuxFilter = [];
  getInvoiceMonthOrReference = getInvoiceMonthOrReference;
  moment = moment;
  fileSrc = null;
  EXEMPT = 50130004;
  ADDITIONAL_INVOICE = 50440002;
  ADDITIONAL_FLAG = 'A';
  SETTLED = 'quitado';
  OPENED = 'Em Aberto';
  isOpenTable = true;
  isOpen = [false, false];

  agreementInvoiceValue = 0;
  oneTimePaymentData = {
    oneTimePaymentInvoiceDocumentStatus: null,
    oneTimePaymentId: null,
    oneTimePaymentValue: 0,
    oneTimePaymentOwnerDocument: '',
    oneTimePaymentRepresentative: false
  };

  oneTimePaymentInvoiceOverdue = null;
  isOneTimePayment = false;
  displayedSituations = [
    'ALL_ORDERS',
    'PAID_OFF',
    'PENDING',
    'DUPLICATED',
    'NEGOTIATED',
    'OVERDUE',
    'EXEMPT'
  ];

  modalFilter = {
    show: false,
    forms: [],
    initialForm: []
  };

  modalNegotiation = {
    show: false,
    forms: [],
    initialForm: []
  };

  modalExtension = {
    show: false
  };

  writeOff = {
    show: false,
    forms: [],
    initialForm: []
  };

  columns = [
    {
      name: 'ref',
      label: 'REF',
      align: 'center',
      value: 'ref',
      field: 'ref',
      expandProp: false
    },
    {
      name: 'valor',
      align: 'center',
      label: 'Valor/Vencimento Original',
      value: 'valor',
      field: 'valor',
      expandProp: true
    },
    {
      name: 'vencimentoAtual',
      align: 'center',
      label: 'Vencimento atual',
      value: 'vencimentoAtual',
      field: 'vencimentoAtual',
      expandProp: true
    },
    {
      name: 'newValue',
      align: 'center',
      label: 'Valor Atualizado',
      value: 'newValue',
      field: 'newValue',
      expandProp: true
    },
    {
      name: 'invoiceStatus',
      align: 'center',
      label: 'Situação',
      value: 'situacao',
      field: 'invoiceStatus',
      expandProp: false
    },
    {
      name: 'dtpagto',
      align: 'center',
      label: 'Data de pagamento',
      value: 'dtpagto',
      field: 'dtpagto',
      expandProp: true
    },
    {
      name: 'status',
      align: 'center',
      label: 'Status',
      value: 'status',
      field: 'status',
      expandProp: true
    },
    {
      name: 'tipocob',
      align: 'center',
      label: 'Forma de Pagamento',
      value: 'tipocob',
      field: 'tipocob',
      expandProp: true
    }
  ];

  get invoiceStatus () {
    return invoiceStatus()
  }

  get headerItems () {
    const headerItems = [
      {
        title: this.$gettext('OVERDUE'),
        content: `(${this.overdue.length}) ${this.overdue.value}`
      },
      {
        title: this.$gettext('PENDING'),
        content: `(${this.upcoming.length}) ${this.upcoming.value}`
      },
      {
        title: this.$gettext('NEGOTIATED'),
        content: `(${this.negotiated.length}) ${this.negotiated.value}`
      },
      {
        title: this.$gettext('PAID_OFF'),
        content: `(${this.paidOff.length}) ${this.paidOff.value}`
      },
      {
        title: this.$gettext('SELECTED_GRID'),
        content: `(${this.selectedInformation.length}) ${this.selectedInformation.value}`
      },
      {
        title: this.$gettext('ONE_TIME_PAYMENT'),
        content: `${this.$toLocaleStringBr(this.oneTimePaymentData.oneTimePaymentValue)}`,
        disable: this.isDisableOneTimePayment
      }
    ]
    return headerItems
  }

  get isDisableOneTimePayment () {
    return this.oneTimePaymentData.oneTimePaymentInvoiceDocumentStatus != 50240002 ||
    (!this.isOwnerInServiceRequest(this.oneTimePaymentData.oneTimePaymentOwnerDocument) &&
    !this.oneTimePaymentData.oneTimePaymentRepresentative) || this.isOneTimePaymentOverdue()
  }

  isOneTimePaymentOverdue () {
    if (!this.oneTimePaymentInvoiceOverdue) {
      return true
    }

    const overdueDate = moment(this.oneTimePaymentInvoiceOverdue).startOf('day')
    const currentDate = moment().startOf('day')

    return currentDate.isAfter(overdueDate)
  }

  get isDisableNegotiationBtn () {
    const invalidItems = this.dataSelected.filter((d) => {
      const isExempt = d.invoiceStatus === this.invoiceStatus.EXEMPT.key
      const isRegularAndOverdue =
        d.invoiceStatus === this.invoiceStatus.REGULAR.key && d.isOverdue
      const isPayed = d.invoiceStatus === this.invoiceStatus.PAID.key
      const isNegotiated = d.invoiceStatus === this.invoiceStatus.NEGOTIATION.key
      return isExempt || isNegotiated || isRegularAndOverdue || isPayed || d.valor === '0,00'
    })

    return (
      invalidItems.length > 0 || this.dataSelected.length === 0
    )
  }

  get oneTimePayment () {
    return {
      value: this.$toLocaleStringBr(this.oneTimePaymentData.oneTimePaymentValue),
      length: ''
    }
  }

  get paidOff () {
    const invoicesWithPayment = this.summaryInvoices?.filter((invoice) => !!invoice.vlpag)
    const sum = invoicesWithPayment?.reduce(
      (accumulator, row) => accumulator + this.$validarFloat(row.vlpag),
      0
    )
    const fullyPaid = this.summaryInvoices?.filter((invoice) => invoice.invoiceStatus === this.invoiceStatus.PAID.key)
    return this.buildSummaryObject(sum, fullyPaid?.length)
  }

  get overdue () {
    const overdueInvoices = this.summaryInvoices?.filter(
      (invoice) => !!invoice.newValue && invoice.invoiceStatus !== this.invoiceStatus.NEGOTIATION.key
    )
    const sum = this.sumValues(overdueInvoices)
    return this.buildSummaryObject(sum, overdueInvoices?.length)
  }

  get upcoming () {
    const upcomingInvoices = this.summaryInvoices?.filter(
      (invoice) => invoice.invoiceStatus === this.invoiceStatus.REGULAR.key && !invoice.newValue
    )
    const sum = this.sumValues(upcomingInvoices)
    return this.buildSummaryObject(sum, upcomingInvoices?.length)
  }

  get negotiated () {
    const negotiatedInvoices = this.summaryInvoices?.filter(
      (invoice) => invoice.invoiceStatus === this.invoiceStatus.NEGOTIATION.key
    )
    const sum = this.sumValues(negotiatedInvoices)
    return this.buildSummaryObject(sum, negotiatedInvoices?.length)
  }

  get isDebtAnotherOwner () {
    return 10 > 1
  }

  shouldShowNewValue (row, col) {
    return !!row.newValue &&
      row.invoiceStatus !== this.invoiceStatus.PAID.key &&
      parseFloat((col.value || row.newValue).toString().replace(',', '.')) > 0
  }

  shouldShowRemainingDebt (row) {
    return !!row.vlpag &&
      row.invoiceStatus !== this.invoiceStatus.PAID.key &&
      parseFloat(row.remainingDebtValue.toString().replace(',', '.')) > 0
  }

  getTotalInformation (situation) {
    const filter = this.filterData(situation)
    const sum = this.sumValues(filter)
    const value = this.$toLocaleStringBr(sum)
    return {
      value: value || this.$toLocaleStringBr(0),
      length: filter?.length
    }
  }

  alterSelected (owner, index) {
    this.data = this.data.map((invoice) => {
      return invoice.owner == owner
        ? { ...invoice, selected: this.allSelected[index] }
        : { ...invoice }
    })
  }

  async openInvoiceManagerCommon (endpoint, params) {
    const { pdf } = await repository.resolveLogic(endpoint, params)
    await this.__whenGenerationFormatIsOnline({ nmArquivo: pdf })
  }

  colorInvoiceDocumentIcon (invoiceDocumentStatusId) {
    switch (invoiceDocumentStatusId) {
      case 50240004:
        return 'tw-text-red-500'
      case 50240002:
        return 'tw-text-gray-500'
      default:
        return ''
    }
  }

  async openInvoiceManager () {
    if (!this.validateOverdueInvoices()) {
      return
    }
    const params = { ids: this.dataSelected.map((row) => row.id).reverse() }
    await this.openInvoiceManagerCommon('invoice.pesquisarHtmlInvoice', params)
  }

  validateOverdueInvoices () {
    const dtvencto = this.dataSelected.filter((d) => {
      const dtvencto = moment(d.dtvencto, 'DD/MM/YYYY')
      return moment().isAfter(dtvencto)
    })
    return true
  }

  async openInvoiceManagerOneTimePayment () {
    const params = { consumerUnit: this.consumerUnit }
    await this.openInvoiceManagerCommon(
      'invoice.pesquisarHtmlInvoiceOneTimePayment',
      params
    )
  }

  async openNegotiationModal () {
    const formatoData = 'DD/MM/YYYY'
    const dataAtual = this.moment()
    const notReadjustmentItems = this.dataSelected.filter((invoice) => {
      const dataInformadaMoment = moment(invoice.dtvencto, formatoData)
      const isAtctualMonth =
        dataInformadaMoment.isSame(dataAtual, 'month') &&
        dataInformadaMoment.isSame(dataAtual, 'year')
      return (
        !isAtctualMonth && invoice.newValue && isNaN(Number(invoice.correctionValue))
      )
    })
    if (notReadjustmentItems.length > 0) {
      this.$jt.messageBox.warn(this.$gettext('REGISTER_ADJUSTMENT_CORRECTION'))
    } else {
      this.negotiationController.setInvoices(this.dataSelected)
      this.modalNegotiation.show = true
    }
  }

  openExtensionModal () {
    this.extensionController.setInvoices(this.dataSelected)
    this.modalExtension.show = true
  }

  isInvoiceOverdue (invoice) {
    const dtvencto = moment(invoice.dtvencto, 'DD/MM/YYYY')
    const writeoffDays = invoice.writeOffDays || 0
    const dtvenctoPlusWriteOffDays = dtvencto.clone().add(writeoffDays, 'days')
    return moment().isAfter(dtvenctoPlusWriteOffDays)
  }

  get isDisableInvoiceButton () {
    const hasOverdueInvoices = this.dataSelected.some(this.isInvoiceOverdue)
    const validItemsSelected = this.dataSelected.filter((d) => {
      return (
        d.invoiceDocumentStatusId == 50240002 && d.invoiceStatus != 50130006 && d.valor != '0,00'
      )
    }).length
    return (
      hasOverdueInvoices || validItemsSelected != this.dataSelected.length ||
      !this.dataSelected.length
    )
  }

  get invoiceButtonTooltip () {
    if (!this.dataSelected.length) {
      return this.$gettext('NO_INVOICES_SELECTED')
    }
    const hasOverdueInvoices = this.dataSelected.some(this.isInvoiceOverdue)
    if (hasOverdueInvoices) {
      return this.$gettext('OVERDUE_INVOICES_SELECTED')
    }

    const validItemsSelected = this.dataSelected.filter((d) => {
      return (
        d.invoiceDocumentStatusId == 50240002 && d.invoiceStatus != 50130006 && d.valor != '0,00'
      )
    }).length

    if (validItemsSelected != this.dataSelected.length) {
      return this.$gettext('INVALID_INVOICES_SELECTED')
    }

    const cancelleInvoice = this.dataSelected.filter((d) => {
      return (
        d.invoiceDocumentStatusId == 50240004
      )
    }).length

    if (cancelleInvoice != this.dataSelected.length) {
      return this.$gettext('INVALID_INVOICES_SELECTED')
    }

    return this.$gettext('ERROR_PRINT_INVOICE')
  }

  sendEmailInvoices (email) {
    this.sendEmailInvoiceManager(
      this.dataSelected.map((row) => row.id),
      email
    )
      .then(() => {
        this.$refs.sendEmailModal.hide()
        this.$messageBox.showSuccess(this.$gettext('INVOICE_SEND'))
      })
      .catch((e) => {
        this.$messageBox.showError(this.$gettext('INVOICE_SEND'))
      })
  }

  showSendEmailDialog () {
    if (!this.validateOverdueInvoices()) {
      return
    }
    this.isOneTimePayment = false
    this.$refs.sendEmailModal.show()
  }

  showSendEmailDialogOneTimePayment () {
    this.isOneTimePayment = true
    this.$refs.sendEmailModal.show()
  }

  async sendEmailInvoiceManager (invoiceIds, email) {
    if (this.isOneTimePayment) {
      const params = { consumerUnit: this.consumerUnit, email }
      return await repository.resolveLogic(
        'invoice.sendEmailInvoiceManagerOneTimePayment',
        params
      )
    } else {
      const params = { ids: invoiceIds, email }
      return await repository.resolveLogic(
        'invoice.sendEmailInvoiceManager',
        params
      )
    }
  }

  emailServiceRequest () {
    return this.controller.state.serviceRequests[this.protocol].clientEmail
  }

  async onGenerateReportClick () {
    try {
      const data = JSON.stringify(this.reportData())
      const resolveLogicResult = await this.$jt.repository.resolveLogic(
        'serviceRequestInvoiceReport.serviceRequestInvoiceReport',
        { data, relFormatoRelatorio: 1, relFormaGeracao: 1 }
      )
      await this.__whenGenerationFormatIsOnline(resolveLogicResult)
    } catch (error) {
      console.error(error)
    }
  }

  async openWriteOffModal () {
    this.writeOff.forms =
      await this.invoiceController.serviceRequestExemptionForm()
    this.writeOff.show = true
  }

  reportData () {
    return this.data.map((row) => {
      const value =
        typeof row.valor == 'string'
          ? row.valor.replace(',', '.')
          : String(row.valor)
      return {
        date: `${row.mes}/${row.ano}`,
        year: row.ano,
        dtvencto: row.dtvencto,
        dtvenctoOriginal: row.dtvenctoOriginal || row.dtvencto,
        valor: value,
        vlpag: row.vlpag,
        tipocob: row.tipocob,
        situacao: row.situacao
      }
    })
  }

  toggleTable (index) {
    this.$set(this.isOpen, index, !this.isOpen[index])
  }

  get dataSelected () {
    const dataReturn = this.data?.filter((v) => v.selected)
    return dataReturn
  }

  amountPaid (installmentsSimpleAgreement) {
    return this.sumAtributeArray(installmentsSimpleAgreement, 'vl_pago')
  }

  amountToPaid (totalValue, parcelasAcordoSimples) {
    return totalValue - this.amountPaid(parcelasAcordoSimples)
  }

  sumAtributeArray (arr, atribute) {
    return arr.reduce((acumulador, obj) => {
      return acumulador + obj[atribute]
    }, 0)
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'pdf',
        '',
        'application/pdf'
      )

      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        this.$refs.reportModal.show()
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  get situationMap () {
    return situationMap
  }

  getSituatinByKey (key) {
    if (key) {
      for (const situation in this.situationMap) {
        if (
          Object.prototype.hasOwnProperty.call(this.situationMap, situation)
        ) {
          const situationKeys = this.situationMap[situation].keys || []
          if (situationKeys.includes(key.toString())) {
            return this.situationMap[situation]
          }
        }
      }
    }
    return { text: key, color: '#fff' }
  }

  async mounted () {
    await this.updateTable()
    this.isOpen = this.invoicesByOwner.map((_, index) => index === 0)
    await this.setOnePaymentValue()
  }

  isOwnerInServiceRequest (ownerDocument) {
    return ownerDocument == this.controller.state.serviceRequests[this.protocol].clientID
  }

  isInvoiceFromCurrentClientContext (invoice) {
    const isRepresentative =
      invoice?.representative === true || invoice?.representative === 'true'
    return isRepresentative || this.isOwnerInServiceRequest(invoice?.ownerDocument)
  }

  get summaryInvoices () {
    return this.data?.filter((invoice) => this.isInvoiceFromCurrentClientContext(invoice))
  }

  calculateInvoiceValue (row) {
    if (row.vlpag && row.invoiceStatus === this.invoiceStatus.PAID.key) {
      return this.$validarFloat(row.vlpag)
    }
    if (row.newValue) {
      return this.$validarFloat(row.newValue)
    }
    return this.$validarFloat(row.valor)
  }

  buildSummaryObject (sum, length) {
    const value = this.$toLocaleStringBr(sum)
    return {
      value: value || this.$toLocaleStringBr(0),
      length: length
    }
  }

  async setOnePaymentValue () {
    const { client } = this.controller.state.serviceRequests[this.protocol]
    const params = { consumerUnit: this.consumerUnit, client: client }
    const response = await repository.resolveLogic(
      'invoiceDocument.pesquisarOneTimePaymentValue',
      params
    )

    this.oneTimePaymentData = {
      oneTimePaymentId: response.id,
      oneTimePaymentValue: response.value,
      oneTimePaymentOwnerDocument: response.payerDocumentNumber,
      oneTimePaymentInvoiceDocumentStatus: response.invoiceDocumentStatus,
      oneTimePaymentRepresentative: response.representative
    }

    this.oneTimePaymentInvoiceOverdue = response.expiredOverdue
  }

  setDateDMA (dateToConvert) {
    const date = dateToConvert?.split(' ')[0]
    return date?.includes('-')
      ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : date
  }

  get dataTable () {
    return this.data
  }

  filterInvoice (text) {
    this.data = this.dataAuxFilter
    if (text !== 'ALL') {
      const keysFilter = this.situationMap[text].keys
      if (text === 'OVERDUE') {
        this.data = this.dataAuxFilter.filter((invoice) => {
          return !(!invoice.newValue || invoice.invoiceStatus == this.invoiceStatus.NEGOTIATION.key)
        })
      } else if (text === 'NEGOTIATED') {
        this.data = this.dataAuxFilter.filter((invoice) => {
          return keysFilter.includes(String(invoice.invoiceStatus))
        })
      } else {
        this.data = this.dataAuxFilter.filter((invoice) => {
          return keysFilter.includes(invoice.situacao) && (invoice.newValue == null && invoice.newValue == undefined)
        })
      }
      for (let index = 0; index < this.allSelected.length; index++) {
        this.allSelected[index] = false
      }
    }
  }

  async openModalFilter () {
    this.modalFilter.forms = await this.invoiceController.formFilter()
    this.modalFilter.initialForm = this.modalFilter.forms
    this.modalFilter.show = true
  }

  async updateTable () {
    this.data = await this.invoiceController.sigreInvoicesByUnid()
    this.data = this.data.map((row) => {
      return {
        ...row,
        selected: false,
        dtvencto: this.setDateDMA(row.dtvencto),
        dtvenctoOriginal: this.setDateDMA(row.dtvencto_original)
      }
    })
    this.dataAuxFilter = this.data
  }

  get invoicesByOwner () {
    const invoicesByOwner = this.dataTable.reduce((acc, invoice) => {
      const ownerId = invoice.owner != null ? invoice.owner : -1

      let index

      if (ownerId === -1) {
        index = acc.findIndex(
          (group) => group.length > 0 && group[0].owner === undefined
        )

        if (index === -1) {
          index = acc.length
          acc.push([])
        }
      } else {
        index = acc.findIndex(
          (group) => group.length > 0 && group[0].owner === ownerId
        )

        if (index === -1) {
          index = acc.length
          acc.push([])
        }
      }

      acc[index].push(invoice)
      return acc
    }, [])
    for (
      let index = 0;
      this.allSelected.length <= invoicesByOwner.length;
      index++
    ) {
      this.allSelected.push(false)
    }
    return invoicesByOwner
  }

  get invoiceDocumentTitle () {
    return (
      this.consumerUnit +
      '_' +
      this.dataSelected[0]?.ownerName.replace(' ', '_')
    )
  }

  actionButtonFilter (button, params) {
    this.updateTable()
    const initialData = this.data || []
    this.data = this.filterTableDate('ano', params.reference)
    this.data = this.filterTableDate(
      'dtvenctoOriginal',
      params.dueDateOriginal
    )
    this.data = this.filterTableDate('dtvencto', params.dueDate)
    if (!this.data.length) {
      this.data = initialData
    }
    this.modalFilter.show = false
  }

  async actionButtonWriteOff (action, data) {
    const totalInvoicesValue = this.selectedInformationWriteOff
      .map((element) => parseFloat(element.valor.replace(',', '.')))
      .reduce((accumulator, currentValue) => {
        return accumulator + currentValue
      }, 0.0)
    const invoices = this.selectedInformationWriteOff.map((element) => ({
      exemptValue: element.valor,
      invoice: element.id
    }))
    await this.invoiceController.serviceRequestExemptionRecord({
      ...data,
      totalExemptValue: totalInvoicesValue,
      exemptInvoicesString: JSON.stringify(invoices)
    })
    await this.invoiceController.createConsumerUnitFile({
      ...data,
      consumerUnit: this.consumerUnit
    })
    this.writeOff.show = false
    const filteredArray = this.data?.filter((v) => v.selected && !v.isSigre)
    for (let index = 0; index < filteredArray.length; index++) {
      filteredArray[index].invoiceStatus = this.EXEMPT
      filteredArray[index].selected = false
    }

    this.updateTable()
  }

  filterTableDate (filterKey, datesBetween) {
    const { initial, final } = datesBetween || {}
    if (!initial && !final) {
      return this.data
    }

    const dateFormat = filterKey !== 'ano' ? 'DD/MM/YYYY' : 'MM/YYYY'
    const startDate = initial
      ? this.moment(initial, dateFormat)
      : this.moment('01/01/0001', 'DD/MM/YYYY')
    const endDate = final ? this.moment(final, dateFormat) : this.moment()

    const filteredData = this.data.filter((row) => {
      const dateTable =
        filterKey !== 'ano'
          ? this.moment(row[filterKey], 'DD/MM/YYYY')
          : this.moment(`01/${row.mes}/${row.ano}`, 'DD/MM/YYYY')
      return this.isBetweenOrSame(dateTable, startDate, endDate)
    })

    if (filteredData.length === 0) {
      messageBox.warn(this.$gettext('NO_FILTER_DATA'))
    }

    return filteredData
  }

  isBetweenOrSame (date, startDate, endDate) {
    return date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate)
  }

  sumValues (arr) {
    return arr?.reduce((accumulator, row) => accumulator + this.calculateInvoiceValue(row), 0)
  }

  filterData (situation) {
    return this.data?.filter((row) => {
      return situation.includes(row.situacao)
    })
  }

  get selectedInformation () {
    const filter = this.summaryInvoices?.filter((v) => v.selected)
    const sum = this.sumValues(filter)
    return this.buildSummaryObject(sum, filter?.length)
  }

  get selectedInformationWriteOff () {
    const filter = this.data?.filter((v) => v.selected && !v.isSigre)
    return filter
  }

  showOneTymePayment () {
    alert('TODO')
  }

  showParcialValuePaid (row) {
    if (row.valor && row.vlpag) {
      return (
        Number(row.valor.replace(',', '.')) -
        Number(row.vlpag.replace(',', '.'))
      )
    }
    return 0
  }

  getStatusIcon (status) {
    switch (status.agreementInvoiceType) {
      case 50310001:
        return {
          icon: 'mdi-checkbox-multiple-marked-circle-outline',
          tooltip: 'Acordo',
          color: '#b68aff'
        }
      case 50310002:
        return {
          icon: 'mdi-calendar-plus',
          tooltip: 'Prorrogação de boleto',
          color: '#2196f3'
        }
      case 50310003:
        return {
          icon: 'mdi-group',
          tooltip: 'Agrupado',
          color: '#ff9800'
        }
    }
  }
}

export default ServiceRequestInvoice
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";

.table-header {
  position: relative;
  top: 0;
  z-index: 10;
}

#header {
  position: relative;
  width: 100%;
  z-index: 1000;
  background-color: white;
}
.cell-values {
  display: flex;
  flex-direction: column;
}

.table {
  margin-top: 40px;
}

.buttons-area {
  min-height: 55px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 16px;
  align-items: center;
}

.index-table {
  flex: 1 1 auto;
  min-width: 250px;
  margin: 0;
}

.rigth-buttons {
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 300px;
}

.sub-teble-btn {
  color: #555;
  white-space: nowrap;
  min-width: fit-content;
}

.top-area {
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.payment-value {
  color: #4CAF50;
  margin-right: 4px
}
.abatement-value {
  color: #FFC107;
  margin-right: 4px
}
.restitution-value {
  color: #00BCD4;
  margin-right: 4px
}

@media (max-width: 1366px) {
  .buttons-area {
    flex-direction: column;
    align-items: stretch;
    height: auto;
  }

  .index-table {
    width: 100%;
    margin-bottom: 8px;
  }

  .rigth-buttons {
    width: 100%;
    justify-content: center;
  }

  .sub-teble-btn {
    font-size: 0.9rem;
    padding: 8px 12px;
  }
}

@media (max-width: 768px) {
  .rigth-buttons {
    flex-direction: column;
  }

  .sub-teble-btn {
    width: 100%;
  }
}

</style>
